export default {
  sortArray(data) {
    let _data = Array.from(new Set(data)).sort(function (a, b) {
      if (a[0] === b[0]) {
        var x = a['name']
        var y = b['name']
        return x < y ? -1 : x > y ? 1 : 0
      }
      return a[0] - b[0]
    })
    return _data
  }
}
